import {
  EMBEDDED_CHAT_AUTHORIZE,
  EMBEDDED_CHAT_CONFIGURATION,
} from '@mm/api-routes';
import { EmbeddedChatConfigurationModel } from '../model/EmbeddedChatConfigurationModel';
import AuthenticatedController from './AuthenticatedController';

export class EmbeddedChatController extends AuthenticatedController {
  static getConfiguration(
    facebookPageId?: number,
  ): Promise<EmbeddedChatConfigurationModel> {
    return super.get(EMBEDDED_CHAT_CONFIGURATION(facebookPageId));
  }

  static authorize(
    facebookPageId?: number,
    llrDomain?: string,
  ): Promise<{ remoteUserId: string }> {
    return super.post(EMBEDDED_CHAT_AUTHORIZE(facebookPageId, llrDomain));
  }
}
